import React, { useEffect, useState, useRef } from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  CircularProgress,
  Button,
  Stepper,
  Step,
  StepLabel,
  StepContent,
} from "@mui/material";
import { Sync, CheckCircle } from "@mui/icons-material";
import { fetchProjectsApi } from "../../api/project";
import { addProjects } from "../../indexDB/utils/project";
import { fetchDatasetsApi } from "../../api/dataset";
import { addDataset } from "../../indexDB/utils/dataset";
import { useTheme } from "@mui/material/styles";
import { useErrorBoundary } from "react-error-boundary";
import {syncOneDatapoint} from "../../indexDB/utils/datapoint";
import { db } from "../../indexDB/model";

const OnlineSyncModal = ({ open, onClose, handleLogout }) => {
  const { showBoundary } = useErrorBoundary();
  const projectsRef = useRef([]);
  const datasetNumberRef = useRef(0);
  const [activeStep, setActiveStep] = useState(0);
  const theme = useTheme();
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const projectsData = await fetchProjectsApi(localStorage.getItem("username"));
        if (projectsData) {
          projectsRef.current = projectsData;
          await addProjects(projectsData);
        }
        setActiveStep(1);
        await fetchDatasetsForProjects();
        setActiveStep(2);
        setActiveStep(3);
      } catch (error) {
        showBoundary(error);
      }
    };

    if (open) {
      fetchData();
    }
  }, [open]);

  
  const handleSyncAll = async () => {
    try {
      const datapoints = await db.datapoints.toArray();
      for (const datapoint of datapoints) {
        await handleSyncOne(datapoint.id);
      }
    } catch (error) {
      console.log("Error syncing formdata/datapoints to online:", error);
    }
  };

  const handleSyncOne = async (id) => {
    try {
      const response = await syncOneDatapoint(id, handleLogout);

      if (response === true) {
        console.log("passed sync for", id)
      } 
      // else {
      //   throw new Error("Deletion failed");
      // }
    } catch (error) {
      console.log("Error syncing datapoint", id);
    }
  };


  const fetchDatasetsForProjects = async () => {
    const projectsData = projectsRef.current;
    handleSyncAll()

    if (projectsData.length > 0) {
      for (const project of projectsData) {
        try {
          const datasetsData = await fetchDatasetsApi(project.id);
          await addDataset(datasetsData);
          datasetNumberRef.current += 1;
        } catch (error) {
          showBoundary(error);
        }
      }
    }
  };

  const handleClose = () => {
    onClose();
    setActiveStep(0);
  };

  const getIcon = (step) => {
    const primaryColor = theme.palette.primary.main;
    if (activeStep === step) {
      return <CircularProgress size={20} />;
    } else if (activeStep > step) {
      return <CheckCircle style={{ color: primaryColor }} />;
    } else {
      return step + 1;
    }
  };

  return (
    <Dialog open={open}>
      <DialogContent>
        <Stepper activeStep={activeStep} orientation="vertical">
          <Step>
            <StepLabel icon={getIcon(0)}>
              {activeStep === 0 ? (
                <div style={{ display: "flex", alignItems: "center" }}>
                  Fetching Projects
                </div>
              ) : (
                "Projects Fetched Successfully"
              )}
            </StepLabel>
          </Step>
          <Step>
            <StepLabel icon={getIcon(1)}>
              {activeStep === 1 || activeStep === 0 ? (
                <div style={{ display: "flex", alignItems: "center" }}>
                  Fetching Datasets
                </div>
              ) : (
                "Datasets Fetched Successfully"
              )}
            </StepLabel>
          </Step>
          <Step>
            <StepLabel icon={getIcon(2)}>
              {activeStep === 1 || activeStep === 0 ? (
                <div style={{ display: "flex", alignItems: "center" }}>
                  Sync In Progress
                  {activeStep === 2 && (
                    <CircularProgress
                      size={20}
                      style={{ marginLeft: "10px" }}
                    />
                  )}
                </div>
              ) : (
                projectsRef.current.length === 0 ? "Sorry, it looks like you don't have any assigned projects" : `Sync Completed (Fetched ${projectsRef.current.length} projects)`
              )}
            </StepLabel>
          </Step>
        </Stepper>
        {activeStep === 3 && (
          <>
            <Button
              variant="contained"
              onClick={handleClose}
              style={{ marginTop: "20px", width: "100%" }}
            >
              Close
            </Button>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default OnlineSyncModal;
